import type { DashboardSettingsTab } from '@features/dashboard'
import { AccountSecurityPanel } from '@features/account'
import type { DashboardUserProfile } from '@services/firebase'
import { AccountSettingsCard } from './AccountSettingsCard'
import { AvatarUploadCard } from './AvatarUploadCard'
import { ChangePasswordSettingsCard } from './ChangePasswordSettingsCard'
import { PersonalSettingsCard } from './PersonalSettingsCard'
import { PreferencesSettingsCard } from './PreferencesSettingsCard'
import { ProfileSubscriptionSummary } from './ProfileSubscriptionSummary'

interface SettingsTabPanelsProps {
  readonly onAvatarUploaded: (imageUrl: string) => void
  readonly onBuyKey: () => void
  readonly onEnterKey: () => void
  readonly onProfileSaved: (patch: Partial<DashboardUserProfile>) => void
  readonly profile: DashboardUserProfile
  readonly value: DashboardSettingsTab
}

export function SettingsTabPanels({
  onAvatarUploaded,
  onBuyKey,
  onEnterKey,
  onProfileSaved,
  profile,
  value,
}: SettingsTabPanelsProps) {
  if (value === 'avatar') {
    return (
      <AvatarUploadCard
        onUploaded={onAvatarUploaded}
        profile={profile}
        shell="plain"
      />
    )
  }

  if (value === 'account') {
    return (
      <AccountSettingsCard
        onSaved={onProfileSaved}
        profile={profile}
        shell="plain"
      />
    )
  }

  if (value === 'change-password') {
    return <ChangePasswordSettingsCard profile={profile} shell="plain" />
  }

  if (value === 'security') {
    return <AccountSecurityPanel embedded />
  }

  if (value === 'personal') {
    return (
      <PersonalSettingsCard
        onSaved={onProfileSaved}
        profile={profile}
        shell="plain"
      />
    )
  }

  if (value === 'systems') {
    return (
      <PreferencesSettingsCard
        mode="systems"
        onSaved={onProfileSaved}
        profile={profile}
        shell="plain"
      />
    )
  }

  if (value === 'study-plan') {
    return (
      <PreferencesSettingsCard
        mode="study-plan"
        onSaved={onProfileSaved}
        profile={profile}
        shell="plain"
      />
    )
  }

  if (value === 'subscription') {
    return (
      <ProfileSubscriptionSummary
        onBuyKey={onBuyKey}
        onEnterKey={onEnterKey}
        profile={profile}
      />
    )
  }

  return null
}